// v26.2 §1 — Nájdi prvok (poll — často existuje až po prepnutí tabu a dobehnutí dát),
// vycentruj ho a bliskni bz-flash. Jediný spoločný mechanizmus pre notifikácie.
export function focusEl(selector, fallbackSelector) {
  let n = 0;
  const tick = () => {
    const el = document.querySelector(selector) || (fallbackSelector ? document.querySelector(fallbackSelector) : null);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "center" });
      el.classList.remove("bz-flash"); void el.offsetWidth;  // restart animácie
      el.classList.add("bz-flash");
      setTimeout(() => el.classList.remove("bz-flash"), 2200);
      return;
    }
    if (++n < 20) setTimeout(tick, 120);
  };
  setTimeout(tick, 250);
}
